import { render, staticRenderFns } from "./detail_jbxx.vue?vue&type=template&id=096d9385&scoped=true&"
import script from "./detail_jbxx.vue?vue&type=script&lang=js&"
export * from "./detail_jbxx.vue?vue&type=script&lang=js&"
import style0 from "./detail_jbxx.vue?vue&type=style&index=0&id=096d9385&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d9385",
  null
  
)

export default component.exports